export const domainCheck = (
  url: string
): { isSubDomain: boolean; pureDomain: string } => {
  url = url.trim();

  // Remove protocols
  url = url.replace(/^http:\/\/|^https:\/\/|^ftp:\/\//i, '');

  // Remove 'www.' from the start
  url = url.replace(/^www\./i, '');

  const fullDomain = url;

  // Extract pure domain, handling ccTLDs like '.co.uk' or '.uk.com'
  const domainMatch = url.match(/([a-z0-9-]+\.[a-z]{2,}(?:\.[a-z]{2,})?)$/i);
  const pureDomain = domainMatch ? domainMatch[0] : url;

  // Determine if it's a subdomain
  const isSubDomain = fullDomain !== pureDomain;

  return {
    isSubDomain: isSubDomain,
    pureDomain: pureDomain
  };
};
